const OPENINSTALL_SDK_BASE = "https://res.openinstalljs.com/openinstall";

/**
 * 按 appKey 动态加载 OpenInstall SDK（每个应用对应 openinstall-{appKey}.js）
 */
export function loadOpenInstallSdk(appKey) {
  if (!appKey) {
    return Promise.reject(new Error("OpenInstall appKey 不能为空"));
  }

  const scriptId = `openinstall-sdk-${appKey}`;
  const existingScript = document.getElementById(scriptId);

  if (existingScript && window.OpenInstall) {
    return Promise.resolve(window.OpenInstall);
  }

  document
    .querySelectorAll("script[data-openinstall]")
    .forEach((el) => el.remove());

  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.id = scriptId;
    script.dataset.openinstall = appKey;
    script.src = `${OPENINSTALL_SDK_BASE}-${appKey}.js`;
    script.async = true;
    script.onload = () => {
      if (window.OpenInstall) {
        resolve(window.OpenInstall);
      } else {
        reject(new Error(`OpenInstall SDK 加载后未挂载到 window: ${appKey}`));
      }
    };
    script.onerror = () => {
      reject(new Error(`OpenInstall SDK 加载失败: ${appKey}`));
    };
    document.head.appendChild(script);
  });
}
